export default __webpack_public_path__ + "static/media/pin-pause.56dc6fe8.svg";